import { Box } from '@mui/material';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import ChartSection from '../shared/ChartSection';
import useNivoTheme from '../shared/useNivoTheme';

export default function GradeVsFrequency({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const scatterData = [{
        id: 'Members',
        data: data.map(d => ({ x: d.trades, y: d.score, name: d.name, grade: d.grade })),
    }];

    return (
        <ChartSection id="grade-frequency" title="Do the best traders trade more or less frequently?" subtitle="X = number of trades, Y = CG Score. Are the best traders selective or prolific?">
            <Box sx={{ height: 400 }}>
                <ResponsiveScatterPlot
                    data={scatterData}
                    margin={{ top: 20, right: 20, bottom: 60, left: 60 }}
                    xScale={{ type: 'linear', min: 0, max: 'auto' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto' }}
                    nodeSize={7} colors={[colors.primary]}
                    axisBottom={{ legend: 'Number of Trades', legendPosition: 'middle', legendOffset: 46 }}
                    axisLeft={{ legend: 'CG Score', legendPosition: 'middle', legendOffset: -45 }}
                    tooltip={({ node }) => (
                        <Box sx={{ bgcolor: 'custom.surface.elevated', p: 1.5, borderRadius: 1, border: t => '1px solid ' + t.palette.custom.border.default }}>
                            <Box sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.875rem' }}>{node.data.name} ({node.data.grade})</Box>
                            <Box sx={{ color: 'text.muted', fontSize: '0.75rem' }}>{node.data.x} trades · Score: {node.data.y}</Box>
                        </Box>
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
